export default __webpack_public_path__ + "static/featurePhone3-a30eaa95c24689e3c9ab3f6ead231488.png";